import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig, //寄送，支付接口
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
import NProgress from 'nprogress';
import $http from '$http';
import viewPhoto from 'src/common/js/viewPhoto';
export default {
    mixins: [services],
    components: {},
    props: {
        value: {
            type: Boolean,
            default: null
        },
    },
    created() {


    },
    data() {
        return {
            num: 1,
            loading: false,
            agent: '',
            school: '',
            form: this.getSubmitFormData(),
            SchoolConsigneeList: [],
            ConsigneeList: '', //收货地址
            ConsigneeListName: '', //联系人及电话
            dialogVisible: false, //没有园所提示的弹窗
            AddDialogVisible: false,
            showData: this.getShowData(), //弹窗传参
            pageIndex: 1,
            pageSize: 10,
            totalNum: 0
        }
    },
    methods: {

        getSubmitFormData() {
            return cloneDeep({
                "ClassNum": 0,
                "ClassList": [],
                "MoreClassNum": 0,
                "OrderPrice": 0,
                "SchoolConsigneeId": 0,
                "OrderId": 0,
                "TimeStamp": 0,
                "PackageId": 1013,
                "SendMode": 223,
                "PayMode": 222,
                "ListMeetPay": [],
                "GoodsList": [],
                "AgentId": 0,
                "SchoolId": 0,
                "AgentStyle": '',
                "PayObject": '',
                OrderRemark: ''
            });
        },
        getShowData() {
            return cloneDeep({
                title: '',



            });
        },
        //初始化数据
        initData() {
            this.form = this.getSubmitFormData()
            this.showData = this.getShowData()
            this.school = ""
            this.agent = ""
            this.ConsigneeList = ''
            this.ConsigneeListName = ''
            this.loading = false
        },
        show(options) {
            this.initData();
            this.AddDialogVisible = true
            this.showData.title = options.title
            this.GetById(options.OrderId)

        },


        // 查看图片
        showImgView(img) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{
                    src: img.Url,
                    id: ""
                }]
            });
        },

    },
    computed: {
        packages() {
            return [{
                ProId: 758,
                ProName: '艺术亲子活动包',
                ProNum: 20 * this.form.MoreClassNum
            }]
        },
        courses() {
            // 课程
            if (this.form.MoreClassNum > 0) {
                return [{
                    ProName: '英语寒暑课',
                    ProNum: 12 * this.form.ClassNum
                }, {
                    ProName: '艺术亲子活动课',
                    ProNum: 2 * this.form.MoreClassNum
                }]
            } else {
                return [{
                    ProName: '英语寒暑课',
                    ProNum: 12 * this.form.ClassNum
                }]
            }

        },

    },
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/components/SummerSchoolOrderView/vm.js